import React from 'react';
import PropTypes from 'prop-types';
import FormattedCurrency from '../../../formatted-currency';

import style from './purchase-details.module.less';

const CurrencyComponent = ({ value, currencyCode, label, dataTestId = '' }) => {
  return (
    <div className={style['detail-line']} data-testid={dataTestId}>
      <div className={style.descriptor}>{label}</div>
      <div className={style.content}>
        <FormattedCurrency currencyCode={currencyCode} value={value} />
      </div>
    </div>
  );
};

CurrencyComponent.propTypes = {
  value: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  dataTestId: PropTypes.string,
};

export default CurrencyComponent;
